import { useMutation } from 'react-query';
import {
  deleteMarketInReviewForAdmin,
  softDeleteMarket,
} from '../api/MarketsEndpoints';

export const useSoftDeleteMarket = () => useMutation(softDeleteMarket);
export const useDeleteMarketInReviewForAdmin = () =>
  useMutation(deleteMarketInReviewForAdmin);
